module.exports = __webpack_public_path__ + "img/1.85c6ff45.png";